/**
 * Step navigation for intake flow variants.
 *
 * `request-service` skips screening questions, demographics, and email verification — used when an
 * existing portal client requests an additional therapy service. Group Therapy inserts step 14
 * (cohort selection) after therapy type when `group` is selected, and drops topics, provider
 * preferences, and format — the cohort already answers modality, and matching is deferred to the
 * tracker screening call.
 */

export type IntakeFlowVariant = 'full' | 'request-service';

/** Internal step index for Group Therapy cohort selection (does not renumber steps 0–13). */
export const GROUP_SELECTION_STEP = 14;

/** Which optional steps this run of the flow includes. */
export interface IntakeStepShape {
  hasLocationStep: boolean;
  includeGroupSelection: boolean;
  /**
   * Group-only: skip topics (1), provider preferences (2), and format (4). Format is derived from
   * the cohort modality; matching preferences are collected later on the tracker screening call.
   */
  skipMatchingPreferenceSteps: boolean;
}

export const DEFAULT_STEP_SHAPE: IntakeStepShape = {
  hasLocationStep: false,
  includeGroupSelection: false,
  skipMatchingPreferenceSteps: false,
};

export function isRequestServiceFlow(variant?: IntakeFlowVariant): boolean {
  return variant === 'request-service';
}
